import path from 'path';
import fs, { existsSync } from 'fs';
import getPublicUrlOrPath from 'react-dev-utils/getPublicUrlOrPath.js';

// Locates the project by looking for package.json
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/paths.ts", "<global>"],fileName: "/config/paths.ts",childLine: 6,line: "export const locateProject = (p: string): string | null => {"});
export const locateProject = (p: string): string | null => {
    if (!path.isAbsolute(p)) {
        global.executions.addLine({className: "<global>",functionName: "locateProject",hierarchy: ["/config/paths.ts", "<global>", "locateProject"],fileName: "/config/paths.ts",childLine: 8,line: "        throw new Error('Can not locate project; path must be absolute. Path: ' + p)"});
        throw new Error('Can not locate project; path must be absolute. Path: ' + p)
    }
    if (existsSync(path.resolve(p, 'package.json'))) return p
    if (p === path.parse(path.join(__dirname)).root) return null
    global.executions.addLine({className: "<global>",functionName: "locateProject",hierarchy: ["/config/paths.ts", "<global>", "locateProject"],fileName: "/config/paths.ts",childLine: 12,line: "    return locateProject(path.resolve(p, '../'))"});
    return locateProject(path.resolve(p, '../'))
}

// Make sure any symlinks in the project folder are resolved:
// https://github.com/facebook/create-react-app/issues/637
/**
 * Resolves a path in the app directory
 * @param relativePath the relative path from the app directory (with package.json)
 * @returns the resolved path
*/
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/paths.ts", "<global>"],fileName: "/config/paths.ts",childLine: 22,line: "export const resolveApp = (relativePath: string) => {"});
export const resolveApp = (relativePath: string) => {
    global.executions.addLine({className: "<global>",functionName: "resolveApp",hierarchy: ["/config/paths.ts", "<global>", "resolveApp"],fileName: "/config/paths.ts",childLine: 23,line: "    const appDirectory = locateProject(process.cwd())"});
    const appDirectory = locateProject(process.cwd())
    if (!appDirectory) {
        global.executions.addLine({className: "<global>",functionName: "resolveApp",hierarchy: ["/config/paths.ts", "<global>", "resolveApp"],fileName: "/config/paths.ts",childLine: 25,line: "        throw new Error(`No package.json found`)"});
        throw new Error(`No package.json found`)
    }
    global.executions.addLine({className: "<global>",functionName: "resolveApp",hierarchy: ["/config/paths.ts", "<global>", "resolveApp"],fileName: "/config/paths.ts",childLine: 27,line: "    return path.resolve(appDirectory, relativePath);"});
    return path.resolve(appDirectory, relativePath);
}

// We use `PUBLIC_URL` environment variable or "homepage" field to infer
// "public path" at which the app is served.
// webpack needs to know it to put the right <script> hrefs into HTML even in
// single-page apps that may serve index.html for nested URLs like /todos/42.
// We can't use a relative path in HTML because we don't want to load something
// like /todos/42/static/js/bundle.7289d.js. We have to know the root.
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/paths.ts", "<global>"],fileName: "/config/paths.ts",childLine: 36,line: "const publicUrlOrPath = getPublicUrlOrPath("});
const publicUrlOrPath = getPublicUrlOrPath(
    process.env.NODE_ENV === 'development',
    // require(require.resolve(resolveApp('package.json'))).homepage,
    '/',
    process.env.PUBLIC_URL
);

global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/paths.ts", "<global>"],fileName: "/config/paths.ts",childLine: 43,line: "const buildPathFrontend = process.env.BUILD_PATH_FRONTEND || 'dist/frontend';"});
const buildPathFrontend = process.env.BUILD_PATH_FRONTEND || 'dist/frontend';
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/paths.ts", "<global>"],fileName: "/config/paths.ts",childLine: 44,line: "const buildPathBackend = process.env.BUILD_PATH_BACKEND || 'dist/backend';"});
const buildPathBackend = process.env.BUILD_PATH_BACKEND || 'dist/backend';

global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/paths.ts", "<global>"],fileName: "/config/paths.ts",childLine: 46,line: "export const moduleFileExtensions = ["});
export const moduleFileExtensions = [
    'web.mjs',
    'mjs',
    'web.js',
    'js',
    'web.ts',
    'ts',
    'web.tsx',
    'tsx',
    'json',
    'web.jsx',
    'jsx',
    'svg'
];

// Resolve file paths in the same order as webpack
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/paths.ts", "<global>"],fileName: "/config/paths.ts",childLine: 62,line: "export const resolveModule = (resolveFn: { (relativePath: string): string; (relativePath: string): string; (relativePath: string): string; (arg0: string): fs.PathLike; }, filePath: string) => {    "});
export const resolveModule = (resolveFn: { (relativePath: string): string; (relativePath: string): string; (relativePath: string): string; (arg0: string): fs.PathLike; }, filePath: string) => {    
    global.executions.addLine({className: "<global>",functionName: "resolveModule",hierarchy: ["/config/paths.ts", "<global>", "resolveModule"],fileName: "/config/paths.ts",childLine: 63,line: "    const extension = moduleFileExtensions.find(extension =>"});
    const extension = moduleFileExtensions.find(extension =>
        fs.existsSync(resolveFn(`${filePath}.${extension}`))
    );

    if (extension) {
        global.executions.addLine({className: "<global>",functionName: "resolveModule",hierarchy: ["/config/paths.ts", "<global>", "resolveModule"],fileName: "/config/paths.ts",childLine: 68,line: "        return resolveFn(`${filePath}.${extension}`);"});
        return resolveFn(`${filePath}.${extension}`);
    }

    global.executions.addLine({className: "<global>",functionName: "resolveModule",hierarchy: ["/config/paths.ts", "<global>", "resolveModule"],fileName: "/config/paths.ts",childLine: 71,line: "    return resolveFn(`${filePath}.js`);"});
    return resolveFn(`${filePath}.js`);
};

/** Gets all the paths */
global.executions.addLine({className: "<global>",functionName: undefined,hierarchy: ["/config/paths.ts", "<global>"],fileName: "/config/paths.ts",childLine: 75,line: "export function getPaths() {"});
export function getPaths() {
    global.executions.addLine({className: "<global>",functionName: "getPaths",hierarchy: ["/config/paths.ts", "<global>", "getPaths"],fileName: "/config/paths.ts",childLine: 76,line: "    return {"});
    return {
        dotenv: resolveApp('.env'),
        appPath: resolveApp('.'),
        appBuild: resolveApp(buildPathFrontend),
        backendBuild: resolveApp(buildPathBackend),
        backendPublicUrlOrPath: '/',
        appPublic: resolveApp('public'),
        appBackend: resolveApp('backend'),
        appAssets: resolveApp('assets'),
        appHtml: resolveApp('public/index.html'),
        appIndex: resolveModule(resolveApp, 'frontend/index'),
        appPackageJson: resolveApp('package.json'),
        appFrontend: resolveApp('frontend'),
        appShared: resolveApp('shared'),
        appScripts: resolveApp('scripts'),
        appConfig: resolveApp('config'),
        appRoot: path.join(resolveApp('frontend'), '../'),
        appTsConfig: resolveApp('tsconfig.json'),
        appJsConfig: resolveApp('jsconfig.json'),
        yarnLockFile: resolveApp('yarn.lock'),
        testsSetupFrontend: resolveModule(resolveApp, 'frontend/core/setup-tests'),
        proxySetupFrontend: resolveApp('frontend/core/setup-proxy'),
        proxySetupBackend: resolveApp('backend/core/setup-proxy'),
        appNodeModules: resolveApp('node_modules'),
        appWebpackCache: resolveApp('node_modules/.cache'),
        appTsBuildInfoFile: resolveApp('node_modules/.cache/tsconfig.tsbuildinfo'),
        swSrc: resolveModule(resolveApp, 'frontend/core/service-worker'),
        publicUrlOrPath,
        backendIndex: resolveModule(resolveApp, 'scripts/backend')
    }
}
export default getPaths